define("shared/modifiers/on-escape-key-up", ["exports", "ember-modifier", "shared/utils/constants/keys", "shared/utils/handle-key-up"], function (_exports, _emberModifier, _keys, _handleKeyUp) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-modifier",0,"shared/utils/constants/keys",0,"shared/utils/handle-key-up"eaimeta@70e063a35619d71f
  /**
   *
   * OnEscapeKeyUp adds an event listener to the document, specifically listening for a keyup event with the 'escape' key.
   * When the escape key is pressed, whatever callback has been passed into the modifier will be called.
   *
   * Usage:
   * Will close modal when escape key is pressed:
   * <div {{on-escape-key-up this.closeModal}} />
   *
   */
  var _default = _exports.default = (0, _emberModifier.modifier)((_element, _ref) => {
    let [callback] = _ref;
    const keyHandler = event => (0, _handleKeyUp.default)(event, _keys.default.ESCAPE, callback);
    document.addEventListener('keyup', keyHandler);
    return () => {
      document.removeEventListener('keyup', keyHandler);
    };
  }, {
    eager: false
  });
});